import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import { getAdjustmentApi } from '../../utils/apisConsts';
import DeleteAdjustmentForm from './deleteAdjustmentForm';

class DeleteAdjustment extends Component {
    state = {
        componentSteps: [
            {
                title: 'Adjustment ID',
                content: <GetInfo isAdjustment placeHolder="Enter Adjustment ID" apiLink={getAdjustmentApi}/>,
                id: 0,
            }, {
                title: 'Delete adjustment',
                content: <DeleteAdjustmentForm />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default DeleteAdjustment